document.addEventListener("DOMContentLoaded", function () {

  const toggle = document.getElementById("giftToggle");
  const content = document.getElementById("giftContent");
  const tabs = document.querySelectorAll(".gift-tab");

  const messageForm = document.getElementById("withMessage");
  const noMessageForm = document.getElementById("withoutMessage");

  const saveBtn = document.getElementById("giftSave");
  const cancelBtn = document.getElementById("giftCancel");
  const messageInput = document.getElementById("giftMessage");
  const messageLimit = document.getElementById("giftMessageLimit");
  const messageError = document.getElementById("giftMessageError");
  const maxMessageLength = Number(messageInput.maxLength);

  const updateMessageValidation = () => {
    const messageLength = messageInput.value.length;
    messageLimit.textContent = `${messageLength} / ${maxMessageLength}`;

    const isTooLong = messageLength > maxMessageLength;
    messageError.hidden = messageLength < maxMessageLength;
    messageInput.setAttribute("aria-invalid", String(isTooLong));

    return !isTooLong;
  };

  messageInput.addEventListener("input", updateMessageValidation);

  /* Load saved attributes */
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const attr = cart.attributes;

      if (attr.gift_enabled === "true") {
        toggle.checked = true;
        content.style.display = "block";
      }

      if (attr.gift_message) messageInput.value = attr.gift_message;
      if (attr.gift_receiver) document.getElementById("giftReceiver").value = attr.gift_receiver;
      if (attr.gift_sender) document.getElementById("giftSender").value = attr.gift_sender;

      updateMessageValidation();

      if (attr.gift_type === "no_message") {
        tabs[1].click();
      }
    });

  /* Toggle visibility */
  toggle.addEventListener("change", () => {
    content.style.display = toggle.checked ? "block" : "none";
  });

  /* Tab switching */
  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");

      const target = tab.dataset.target;

      messageForm.classList.toggle("hidden", target !== "withMessage");
      noMessageForm.classList.toggle("hidden", target !== "withoutMessage");
    });
  });

  /* Cancel */
  cancelBtn.addEventListener("click", () => {
    toggle.checked = false;
    content.style.display = "none";
  });

  /* Save */
  saveBtn.addEventListener("click", async () => {
    if (!updateMessageValidation()) {
      messageInput.focus();
      return;
    }

    const data = {
      attributes: {
        gift_enabled: toggle.checked ? "true" : "false",
        gift_type: document.querySelector(".gift-tab.active").dataset.target === "withMessage" ? "with_message" : "no_message",
        gift_message: messageInput.value,
        gift_receiver: document.getElementById("giftReceiver").value,
        gift_sender: document.getElementById("giftSender").value,
      }
    };

    await fetch('/cart/update.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });

    alert("Gift details saved!");
  });

});

// Packaging Selection Logic
document.querySelectorAll(".packaging-card input").forEach((radio) => {
  radio.addEventListener("change", () => {
    const selected = radio.value;

    // Save as cart attribute
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: { Packaging: selected }
      }),
    });
  });
});
